import { render } from "./UkzInvoicesTable.vue?vue&type=template&id=9ac1beac"
import script from "./UkzInvoicesTable.vue?vue&type=script&lang=js"
export * from "./UkzInvoicesTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__